export const GermanFlag = () => (
  <svg
    viewBox="0 0 640 480"
    className="h-4 w-4"
    aria-label="Deutsche Flagge"
    role="img"
  >
    <path fill="#ffce00" d="M0 320h640v160H0z"/>
    <path d="M0 0h640v160H0z"/>
    <path fill="#d00" d="M0 160h640v160H0z"/>
  </svg>
);

export const BritishFlag = () => (
  <svg
    viewBox="0 0 640 480"
    className="h-4 w-4"
    aria-label="British Flag"
    role="img"
  >
    <path fill="#012169" d="M0 0h640v480H0z"/>
    <path fill="#FFF" d="m75 0 244 181L562 0h78v62L400 241l240 178v61h-80L320 301 81 480H0v-60l239-178L0 64V0h75z"/>
    <path fill="#C8102E" d="m424 281 216 159v40L369 281h55zm-184 20 6 35L54 480H0l240-179zM640 0v3L391 191l2-44L590 0h50zM0 0l239 176h-60L0 42V0z"/>
    <path fill="#FFF" d="M241 0v480h160V0H241zM0 160v160h640V160H0z"/>
    <path fill="#C8102E" d="M0 193v96h640v-96H0zM273 0v480h96V0h-96z"/>
  </svg>
);

export const ChineseFlag = () => (
  <svg
    viewBox="0 0 640 480"
    className="h-4 w-4"
    aria-label="中国国旗"
    role="img"
  >
    <defs>
      <path id="a" fill="#ffde00" d="M-.6.8 0-1 .6.8-1-.3h2z"/>
    </defs>
    <path fill="#de2910" d="M0 0h640v480H0z"/>
    <use width="30" height="20" transform="matrix(71.9991 0 0 72 120 120)" xlinkHref="#a"/>
    <use width="30" height="20" transform="matrix(-12.33562 -20.5871 20.58684 -12.33577 240.3 48)" xlinkHref="#a"/>
    <use width="30" height="20" transform="matrix(-3.38573 -23.75998 23.75968 -3.38578 288 95.8)" xlinkHref="#a"/>
    <use width="30" height="20" transform="matrix(6.5991 -23.0749 23.0746 6.59919 288 168)" xlinkHref="#a"/>
    <use width="30" height="20" transform="matrix(14.9991 -18.73557 18.73533 14.99929 240 216)" xlinkHref="#a"/>
  </svg>
);
